import Vue from 'vue'
import TreeTable from 'vue-table-with-tree-grid'

Vue.component('tree-table', TreeTable)
